var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.25 1.25A5.75 5.75 0 0 1 13 7c0 1.317-.445 2.53-1.19 3.499l2.97 2.97a.75.75 0 0 1-1.06 1.061l-2.971-2.97a5.72 5.72 0 0 1-3.499 1.19 5.75 5.75 0 1 1 0-11.5m0 1.5a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5",
    clipRule: "evenodd"
  })));
};
export default Svg16;